import * as React from 'react';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {AttachmentFileState} from '../../types/types';
import {PDF_EXTENSION, PDF_MIME_TYPE} from '../../../../../common/constants/MimeTypeConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {ModalContainerDispatchProps, SendAttachmentsToTargetStateProps} from '../../types/containers';
import {getTargetName} from '../../utils/Utils';
import {CreditoRealSentInfoStatus} from '../../../creditoReal/types/mx/types';

const renderButton = (onPressConfirm, onPressClose, target: string, showSendButton: boolean) => (
    <div>
        <a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
           onClick={onPressClose}>{LOAN_APPLICATION_MX.FILE_DELETE_CANCEL_BUTTON}</a>
        {showSendButton && <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
           onClick={onPressConfirm}>Enviar archivo a {getTargetName(target)}</a>}
    </div>
);

const generateThumbnailUrl = (item: AttachmentFileState) => {
    if (item.mimeType === PDF_MIME_TYPE || item.originalUrl.indexOf(PDF_EXTENSION) >= 0) {
        return AssetsManager('/assets/images/common/pdf-icon-normal.svg');
    }
    return item.thumbnailUrl;
};

const SendAttachmentsTargetView: React.FC<SendAttachmentsToTargetStateProps &
ModalContainerDispatchProps> = ({onPressConfirm, onPressClose, target, file, documentType, creditoRealSentInfoStatus}) => {
    let messageToShow = `Estás por enviar este archivo a ${getTargetName(target)}, por favor asegúrate de que la información esté correcta`;
    let showSendButton = true;
    if (creditoRealSentInfoStatus === CreditoRealSentInfoStatus.NOT_SENT) {
        messageToShow = 'No olvides que primero debes enviar la información xml desde la pestaña "Edición" en la sección "Enviar a CR".';
        showSendButton = false;
    } else if (creditoRealSentInfoStatus === CreditoRealSentInfoStatus.SENT_SUCCESS) {
        messageToShow = 'Información xml enviada exitosamente a CR. Ya puedes enviar este archivo.';
    } else if (creditoRealSentInfoStatus === CreditoRealSentInfoStatus.SENT_ERROR) {
        messageToShow = 'Problemas con el envío. Contactar con tecnología por favor.';
        showSendButton = false;
    }
    return (
        <div className="col-12 p-0">
            <div className="text-justify pb-4">
                <div className={!showSendButton && 'text-warning'}>
                    {messageToShow}
                </div>
                <div className="header-bar hover-actions d-flex justify-content-between align-items-center mt-4">
                    {documentType.label}
                </div>
                <div className="py-4 input-text-enabled">Última modificación: {file.uploadDate.displayValue}</div>
                <div className="col d-flex align-items-center pl-0">
                    <div className="pr-1">
                        <img className="rounded float-left" src={generateThumbnailUrl(file)}
                             alt="thumbnail" width="32px" height="32px"/>
                    </div>
                    <div className="pl-1">
                        <div className="text-description file-link text-primary">
                            {file.fileName}
                        </div>
                        <div className="text-description">
                            {file.uploadUser}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-3 px-0 text-right border-top">
                {renderButton(onPressConfirm, onPressClose, target, showSendButton)}
            </div>
        </div>
    );
};

export default SendAttachmentsTargetView;
